import { Action } from './Action';
import { ADD_ITEMS, LIST_QUERY } from '../../../graphql/shopping-list';

/* eslint-disable no-underscore-dangle */

// TODO Which shopping list are items being added to?

class AddItemsAction extends Action {
  constructor(options) {
    super(options);
    this.items = options.list;
    this.refetchShoppingList = this.component.name !== 'shoppingList';
  }

  static get name() { return 'AddItemsAction'; }

  _executeImpl() {
    const mutateOptions = {
      mutation: ADD_ITEMS,
      variables: {
        items: this.items,
      },
    };

    if (this.refetchShoppingList) {
      mutateOptions.refetchQueries = [{
        query: LIST_QUERY,
        variables: { id: null },
      }];
    } else {
      mutateOptions.update = (store, { data: { shoppingListAddItems } }) => {
        this._updateCache(store, shoppingListAddItems);
      };
    }

    return this.component.$apollo.mutate(mutateOptions);
  }

  /* eslint-disable class-methods-use-this */
  updateQuery(cachedShoppingList, shoppingListAddItemsResult) {
    cachedShoppingList.items.unchecked = shoppingListAddItemsResult.list;
    return cachedShoppingList;
  }
}

export default AddItemsAction;



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/AddItemsAction.js